import { observer } from "mobx-react-lite";

import { useCustomParametersStore } from "../custom-parameters-store";

import { Button } from "@/components/ui/button";

export const Controls = observer(
  ({ onRequestClose, onSave }: { onRequestClose: () => void; onSave: () => void }) => {
    const store = useCustomParametersStore();
    const { currentParameter, isEditingParameter, isViewing } = store;

    if (isViewing) {
      return (
        <Button className="w-full" onClick={onRequestClose} variant="outline" type="button">
          Close
        </Button>
      );
    }

    return (
      <>
        <Button className="w-full" variant="outline" onClick={onRequestClose} type="button">
          Close
        </Button>
        <Button className="w-full" onClick={onSave} disabled={!currentParameter} type="button">
          {isEditingParameter ? "Update Parameter" : "Save Parameter"}
        </Button>
      </>
    );
  },
);
